<template>
  <div id="app" class="container">
    <h1>Vue y Firebase</h1>

    <div class="card">
      <div class="card-header">
        <h3>Agregar un Link</h3>
      </div>

      <div class="card-body">
        <form v-on:submit.prevent="addLink" class="form-inline">

          <div class="form-group">
            <label>Título:</label>
            <input class="form-control" v-model="newLink.title" placeholder="Título" type="text">
          </div>

          <div class="form-group">
            <label>Autor:</label>
            <input class="form-control" v-model="newLink.author" placeholder="Autor" type="text">
          </div>

          <div class="form-group">
            <label>Url:</label>
            <input class="form-control" v-model="newLink.url" placeholder="Url" type="text">
          </div>

          <input type="submit" class="btn btn-success" value="Agregar Link">
        </form>
      </div>
    </div>
    <hr>
    <div class="card">
      <div class="card-header">
        <h3 class="card-title">Lista de Links</h3>
      </div>
      <div class="card-body">
        <table class="table table-striped">
          <thead>
            <tr>
              <th>Título</th>
              <th>Usuario</th>
              <th>Eliminar</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="link in links">
              <td>
                <a target="_blank" v-bind:href="link.url">{{ link.title }}</a>
              </td>
              <td>
                {{ link.author }}
              </td>
              <td>
                <button v-on:click="deleteLink(link)" class="btn btn-danger">
                  <i class="fa fa-trash-o" aria-hidden="true"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import HelloWorld from './components/HelloWorld'
import Firebase from 'firebase';
import Toastr from 'toastr';

let config = {
  apiKey: "AIzaSyCcgdaehT0hRSeD1XfIP_2JLfGCdh1FC0c",
  authDomain: "vuejsfire-72c41.firebaseapp.com",
  databaseURL: "https://vuejsfire-72c41.firebaseio.com",
  projectId: "vuejsfire-72c41",
  storageBucket: "vuejsfire-72c41.appspot.com",
  messagingSenderId: "856549252633"
};

let app = Firebase.initializeApp(config);
let db = app.database();
let linksRef = db.ref('links');

export default {
  name: 'App',
  data () {
    return {
      newLink: {
        title: '',
        author: '',
        url: ''
      }
    }
  },
  firebase: {
    links: linksRef
  },
  methods: {
    addLink: function() {
      linksRef.push(this.newLink);
      this.newLink.title = '';
      this.newLink.author = '';
      this.newLink.url = '';
    },
    deleteLink: function(link) {
      linksRef.child(link['.key']).remove();
      Toastr.success('Link remove');
    }
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

.form-group {
  padding: 20px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue